// extracted by mini-css-extract-plugin
module.exports = {"section":"SubclinicalDiagnosis_section__2ZULw","title":"SubclinicalDiagnosis_title__1nl6Q","header":"SubclinicalDiagnosis_header__393kp","body":"SubclinicalDiagnosis_body__3jzXS"};